//Create a new token

async function GetToken(username, password) {

    if (username.length > 0 && password.length > 0) {

        let response;

        response = await fetch("https://api.cssi.co/login/loginuser", {
            method: "POST",
            body: JSON.stringify(
                {
                    "username": username,
                    "password": password
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default GetToken;